/* eslint-disable max-len */
import { createSvgIcon } from "../utils";

const Plus = createSvgIcon(
    <path
        d="M14 8a1 1 0 011 1v4h4a1 1 0 110 2h-4v4a1 1 0 11-2 0v-4H9a1 1 0 110-2h4V9a1 1 0 011-1z"
        fill="#141313"
    />,
    "Plus",
);

export default Plus;
